<template>
    <div class="Section ProblemSolutionSection" id="problem-solution">
        <div class="SectionContainer">
            <div class="SectionHeader">
                <h2 class="SectionTitle">
                    <span class="TitleAccent">Ihre Probleme, unsere Lösungen</span>
                    Für ein effizienteres Taxiunternehmen
                </h2>
            </div>

            <div class="ColumnHeaders">
                <div class="ColumnHeader ProblemHeader">
                    <div class="HeaderIcon">
                        <i class="ri-close-circle-line"></i>
                    </div>
                    <span>Ohne TaxiFusion</span>
                </div>
                <div class="ColumnHeader SolutionHeader">
                    <div class="HeaderIcon">
                        <i class="ri-checkbox-circle-fill"></i>
                    </div>
                    <span>Mit TaxiFusion</span>
                </div>
            </div>

            <div class="ProblemSolutionGrid">
                <!-- Problem-Solution Pair #1 -->
                <div class="ProblemSolutionPair">
                    <div class="ProblemColumn">
                        <div class="ProblemCard">
                            <div class="ProblemTag">Problem #1</div>
                            <div class="CardIcon">
                                <i class="ri-shield-line"></i>
                            </div>
                            <div class="CardContent">
                                <h3>Gesetzliche Vorgaben</h3>
                                <div class="ProblemImpact">
                                    <i class="ri-file-damage-line"></i>
                                    <span>Bußgelder bis zu 25.000€</span>
                                </div>
                                <p>
                                    Ständig wechselnde Anforderungen (INSIKA/TSE) führen zu hohen
                                    Bußgeldern bei Nichteinhaltung.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="ConnectorLine">
                        <div class="ConnectorDot"></div>
                        <div class="ConnectorArrow">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>

                    <div class="SolutionColumn">
                        <div class="SolutionCard">
                            <div class="SolutionTag">Lösung #1</div>
                            <div class="CardIcon">
                                <i class="ri-shield-check-line"></i>
                            </div>
                            <div class="CardContent">
                                <h3>Gesetzeskonform mit TaxiFusion</h3>
                                <div class="SolutionImpact">
                                    <i class="ri-shield-check-line"></i>
                                    <span>100% rechtlich abgesichert</span>
                                </div>
                                <p>
                                    TaxiFusion hält Sie stets aktuell mit TSE-Anforderungen – ohne
                                    zusätzlichen Aufwand für Sie.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Problem-Solution Pair #2 -->
                <div class="ProblemSolutionPair">
                    <div class="ProblemColumn">
                        <div class="ProblemCard">
                            <div class="ProblemTag">Problem #2</div>
                            <div class="CardIcon">
                                <i class="ri-admin-line"></i>
                            </div>
                            <div class="CardContent">
                                <h3>Aufwändige Verwaltung</h3>
                                <div class="ProblemImpact">
                                    <i class="ri-timer-line"></i>
                                    <span>15+ Stunden/Woche verschwendet</span>
                                </div>
                                <p>
                                    Zeitverschwendung durch komplizierte Software, die mehr Probleme
                                    verursacht als löst.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="ConnectorLine">
                        <div class="ConnectorDot"></div>
                        <div class="ConnectorArrow">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>

                    <div class="SolutionColumn">
                        <div class="SolutionCard">
                            <div class="SolutionTag">Lösung #2</div>
                            <div class="CardIcon">
                                <i class="ri-dashboard-line"></i>
                            </div>
                            <div class="CardContent">
                                <h3>Einfache Verwaltung mit TaxiFusion</h3>
                                <div class="SolutionImpact">
                                    <i class="ri-timer-line"></i>
                                    <span>15+ Stunden/Woche gespart</span>
                                </div>
                                <p>
                                    TaxiFusion bietet intuitive Software, die Ihre
                                    Verwaltungsaufgaben vereinfacht und automatisiert.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Problem-Solution Pair #3 -->
                <div class="ProblemSolutionPair">
                    <div class="ProblemColumn">
                        <div class="ProblemCard">
                            <div class="ProblemTag">Problem #3</div>
                            <div class="CardIcon">
                                <i class="ri-time-line"></i>
                            </div>
                            <div class="CardContent">
                                <h3>Hohe versteckte Kosten</h3>
                                <div class="ProblemImpact">
                                    <i class="ri-money-euro-circle-line"></i>
                                    <span>Bis zu 2.500€ Mehrkosten/Jahr</span>
                                </div>
                                <p>
                                    Verpasste Fristen für P-Scheine und wichtige Dokumente führen zu
                                    hohen finanziellen Einbußen.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="ConnectorLine">
                        <div class="ConnectorDot"></div>
                        <div class="ConnectorArrow">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>

                    <div class="SolutionColumn">
                        <div class="SolutionCard">
                            <div class="SolutionTag">Lösung #3</div>
                            <div class="CardIcon">
                                <i class="ri-money-euro-circle-line"></i>
                            </div>
                            <div class="CardContent">
                                <h3>Intelligente Erinnerungen mit TaxiFusion</h3>
                                <div class="SolutionImpact">
                                    <i class="ri-money-euro-circle-line"></i>
                                    <span>Bis zu 2.500€ gespart/Jahr</span>
                                </div>
                                <p>
                                    TaxiFusion sendet intelligente Benachrichtigungen für P-Scheine,
                                    TÜV und mehr, um Ihre Einnahmen zu sichern.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- CTA Card from Solution.vue -->
            <div class="SolutionCTACard">
                <div class="CTACardContent">
                    <div class="CTACardHeader">
                        <div class="CTAIcon">
                            <i class="ri-rocket-line"></i>
                        </div>
                        <h3>Starten Sie Ihr effizienteres Taxiunternehmen</h3>
                    </div>

                    <div class="CTACardBody">
                        <p>
                            <span class="Highlight">TaxiFusion</span> ist mehr als nur eine
                            Verpflichtung zur Datenspeicherung. Unser Ziel ist es, Ihnen die
                            Werkzeuge an die Hand zu geben, die Sie benötigen, um Ihr Geschäft
                            effizienter und rentabler zu gestalten.
                        </p>
                        <router-link to="/register">
                            <Button size="large">
                                Jetzt Registrieren <i class="ri-arrow-right-line"></i>
                            </Button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/widgets/Button.vue';

export default {
    name: 'ProblemSolutionSection',
    components: {
        Button,
    },
};
</script>

<style lang="scss">
.ProblemSolutionSection {
    padding: 60px 0 80px;
    position: relative;
    overflow: hidden;
    @extend %sectionWrapper;

    @media (max-width: $breakpoint-tablet-portrait) {
        padding: 50px 0 60px;
    }

    .SectionContainer {
        @extend %sectionWrapper;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
        padding: 0 20px;
    }

    .SectionHeader {
        margin-bottom: 40px;
        position: relative;
        text-align: center;

        .HeaderBadge {
            display: inline-block;
            background-color: rgba(45, 55, 72, 0.1);
            color: #2d3748;
            padding: 6px 16px;
            border-radius: 100px;
            font-weight: 600;
            font-size: 0.85rem;
            margin-bottom: 15px;
        }

        .SectionTitle {
            font-size: 2.2rem;
            font-weight: 800;
            color: #2d3748;
            margin: 0 0 20px;
            line-height: 1.2;

            .TitleAccent {
                display: block;
                margin-bottom: 3px;
                color: #0e6c4b;
            }

            @media (max-width: $breakpoint-tablet-portrait) {
                font-size: 1.8rem;
            }

            @media (max-width: $breakpoint-mobile) {
                font-size: 1.6rem;
            }
        }
    }

    .ColumnHeaders {
        display: flex;
        justify-content: space-around;
        margin-bottom: 30px;
        max-width: 1000px;
        margin-left: auto;
        margin-right: auto;
        gap: 100px;
        position: relative;

        @media (max-width: $breakpoint-tablet-landscape) {
            display: none;
        }

        .ColumnHeader {
            display: flex;
            align-items: center;
            padding: 8px 20px;
            border-radius: 100px;
            font-weight: 700;
            font-size: 0.95rem;
            z-index: 2;
            min-width: 160px;
            justify-content: center;

            .HeaderIcon {
                margin-right: 8px;
                display: flex;
                align-items: center;
                justify-content: center;

                i {
                    font-size: 20px;
                }
            }
        }

        .ProblemHeader {
            background-color: rgba(75, 85, 99, 0.1);
            color: #4b5563;

            .HeaderIcon {
                i {
                    color: #4b5563;
                }
            }
        }

        .SolutionHeader {
            background-color: rgba(16, 185, 129, 0.18);
            color: #0e6c4b;

            .HeaderIcon {
                i {
                    color: #0e6c4b;
                }
            }
        }
    }

    .ProblemSolutionGrid {
        display: flex;
        flex-direction: column;
        gap: 40px;
        margin-bottom: 50px;

        @media (max-width: $breakpoint-tablet-landscape) {
            gap: 60px;
        }
    }

    .ProblemSolutionPair {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        gap: 20px;

        @media (max-width: $breakpoint-tablet-landscape) {
            flex-direction: column;
            gap: 20px;
            align-items: center;
        }
    }

    .ProblemColumn,
    .SolutionColumn {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 450px;
        width: 400px;

        @media (max-width: $breakpoint-tablet-landscape) {
            max-width: 100%;
            width: 100%;
        }
    }

    .ColumnLabel {
        display: flex;
        align-items: center;
        padding: 6px 16px;
        border-radius: 100px;
        font-weight: 700;
        font-size: 0.9rem;
        margin-bottom: 20px;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
        background-color: rgba(75, 85, 99, 0.08);
        color: #4b5563;

        .LabelIcon {
            margin-right: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                font-size: 18px;
                color: #4b5563;
            }
        }
    }

    .SolutionLabel {
        background-color: rgba(16, 185, 129, 0.15);
        color: #0e6c4b;

        .LabelIcon {
            i {
                font-size: 18px;
                color: #0e6c4b;
            }
        }
    }

    .ConnectorLine {
        position: relative;
        width: 60px;
        height: 3px;
        background: linear-gradient(90deg, #4b5563, #0e6c4b);
        flex-shrink: 0;
        margin-top: 60px;
        z-index: 1;

        @media (max-width: $breakpoint-tablet-landscape) {
            width: 3px;
            height: 30px;
            background: linear-gradient(180deg, #4b5563, #0e6c4b);
            margin-top: 0;
            margin-bottom: 20px;
            align-self: center;
        }

        .ConnectorDot {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 10px;
            height: 10px;
            background-color: #4b5563;
            border-radius: 50%;

            @media (max-width: $breakpoint-tablet-landscape) {
                left: 50%;
                top: 0;
                transform: translateX(-50%);
            }
        }

        .ConnectorArrow {
            position: absolute;
            right: -8px;
            top: 50%;
            transform: translateY(-50%);
            width: 20px;
            height: 20px;
            background-color: #0e6c4b;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;

            @media (max-width: $breakpoint-tablet-landscape) {
                right: auto;
                left: 50%;
                top: auto;
                bottom: -8px;
                transform: translateX(-50%) rotate(90deg);
            }
        }
    }

    .ProblemCard,
    .SolutionCard {
        background: white;
        border-radius: 12px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
        border: 0.5px solid #e2e8f0;
        width: 100%;

        .CardIcon {
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            border-radius: 12px;
            margin: -25px auto 10px;
            box-shadow: 0 8px 15px rgba(0, 0, 0, 0.12);
            z-index: 2;
            border: 0.5px solid white;

            i {
                font-size: 20px;
            }
        }

        .CardContent {
            padding: 5px 20px 20px;

            h3 {
                font-size: 1.2rem;
                font-weight: 700;
                margin: 0 0 10px;
            }

            p {
                font-size: 0.9rem;
                margin: 0 0 10px;
                line-height: 1.5;
            }
        }
    }

    .ProblemCard {
        .ProblemTag {
            position: absolute;
            top: 10px;
            right: 10px;
            background-color: rgba(75, 85, 99, 0.1);
            color: #4b5563;
            padding: 3px 8px;
            border-radius: 12px;
            font-size: 0.7rem;
            font-weight: 700;
            letter-spacing: 0.3px;
        }

        .CardIcon {
            background-color: #767f8b;
        }

        .CardContent {
            h3 {
                color: #4b5563;
            }

            p {
                color: #6b7280;
            }
        }

        .ProblemImpact {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            background-color: rgba(75, 85, 99, 0.08);
            padding: 6px 12px;
            border-radius: 6px;
            margin-bottom: 10px;

            i {
                color: #4b5563;
            }

            span {
                font-weight: 600;
                color: #4b5563;
                font-size: 0.8rem;
            }
        }

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
            border-color: #4b5563;

            .CardIcon {
                background-color: #374151;
            }
        }
    }

    .SolutionCard {
        .SolutionTag {
            position: absolute;
            top: 10px;
            right: 10px;
            background-color: rgba(16, 185, 129, 0.15);
            color: #0e6c4b;
            padding: 3px 8px;
            border-radius: 12px;
            font-size: 0.7rem;
            font-weight: 700;
            letter-spacing: 0.3px;
        }

        .CardIcon {
            background-color: #0e6c4b;
        }

        .CardContent {
            h3 {
                color: #2d3748;
            }

            p {
                color: #4a5568;
            }
        }

        .SolutionImpact {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            background-color: rgba(16, 185, 129, 0.15);
            padding: 6px 12px;
            border-radius: 6px;
            margin-bottom: 10px;

            i {
                color: #0e6c4b;
            }

            span {
                font-weight: 600;
                color: #0e6c4b;
                font-size: 0.8rem;
            }
        }

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
            border-color: #0e6c4b;

            .CardIcon {
                background-color: #0a5539;
            }
        }
    }

    /* CTA Card Styles from Solution.vue */
    .SolutionCTACard {
        margin-top: 50px;
        background: linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);
        border-radius: 16px;
        box-shadow: 0 12px 25px rgba(0, 0, 0, 0.06);
        border: 0.5px solid #e2e8f0;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4px;
            background: linear-gradient(90deg, #0e6c4b, #10b981 100%);
        }

        .CTACardContent {
            padding: 30px;

            @media (max-width: $breakpoint-tablet-portrait) {
                padding: 25px 20px;
            }
        }

        .CTACardHeader {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            @media (max-width: $breakpoint-mobile) {
                flex-direction: column;
            }

            .CTAIcon {
                flex: 0 0 50px;
                height: 50px;
                background: linear-gradient(135deg, #0e6c4b 0%, #10b981 100%);
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 15px;
                box-shadow: 0 6px 15px rgba(16, 185, 129, 0.2);

                @media (max-width: $breakpoint-mobile) {
                    margin: 0 auto 15px;
                }

                i {
                    font-size: 24px;
                    color: white;
                }
            }

            h3 {
                font-size: 1.4rem;
                font-weight: 700;
                color: #2d3748;
                margin: 0;
                line-height: 1.3;

                @media (max-width: $breakpoint-mobile) {
                    font-size: 1.2rem;
                }
            }
        }

        .CTACardBody {
            color: #4a5568;
            font-size: 1rem;
            line-height: 1.6;

            p {
                margin-bottom: 20px;
            }

            .Highlight {
                font-weight: 800;
                color: #0e6c4b;
            }
        }
    }
}
</style>
